export default "__VITE_PUBLIC_ASSET__26a75f37__"